import { useState } from 'react'
import NumberInput from '../NumberInput.jsx'

const timeText = minute => `${String(Math.floor(minute/60)).padStart(2,'0')}:${String(minute%60).padStart(2,'0')}`

export default function DynamicCanvasSchedule({schedule, onChange}) {
  const [error,setError]=useState('')
  const publish=rows=>{setError('');onChange([...rows].sort((a,b)=>a.minute-b.minute))}
  return <div className="col-span-2 space-y-2" data-testid="dynamic-canvas-schedule">
    <p className="text-xs leading-5 text-inkMuted">Hold zoom between scheduled times. Pan or zoom to pause; Option+R restores the current percentage and resumes.</p>
    <div className="grid grid-cols-[minmax(90px,1fr)_minmax(65px,1fr)_28px] items-center gap-2 text-xs text-ink">
      <span>Time (ET)</span><span>Blank space %</span><span />
      {schedule.map((row,index)=><div className="contents" key={row.minute}>
        {index===0?<span>09:30 · Open</span>:<input type="time" defaultValue={timeText(row.minute)} min="09:31" max="15:59"
          aria-label={`Schedule time ${timeText(row.minute)}`}
          className="min-w-0 h-7 rounded border border-border bg-canvas2 px-1 text-xs text-ink"
          onBlur={event=>{
            const [h,m]=event.target.value.split(':').map(Number), minute=h*60+m
            if(!Number.isInteger(minute)||minute<=570||minute>=960||schedule.some((r,i)=>i!==index&&r.minute===minute)){
              event.target.value=timeText(row.minute);setError('Use a unique time between 09:31 and 15:59.');return
            }
            if(minute!==row.minute)publish(schedule.map((r,i)=>i===index?{...r,minute}:r))
          }} />}
        <NumberInput value={row.blankPercent} min={1} max={95} step={1}
          aria-label={`Blank space at ${timeText(row.minute)}`}
          className="min-w-0 w-full h-7 rounded border border-border bg-canvas2 px-2 text-xs text-ink"
          onValueChange={blankPercent=>publish(schedule.map((r,i)=>i===index?{...r,blankPercent}:r))} />
        {index===0?<span />:<button type="button" className="h-7 text-inkMuted hover:text-ink" aria-label={`Remove ${timeText(row.minute)}`}
          onClick={()=>publish(schedule.filter((_,i)=>i!==index))}>×</button>}
      </div>)}
    </div>
    <button type="button" disabled={schedule.length>=24} className="rounded border border-border px-2 py-1 text-xs text-ink disabled:opacity-40"
      onClick={()=>{
        let minute=Math.min(959,schedule.at(-1).minute+30)
        if(schedule.some(r=>r.minute===minute))minute=Array.from({length:389},(_,i)=>571+i).find(m=>!schedule.some(r=>r.minute===m))
        publish([...schedule,{minute,blankPercent:schedule.at(-1).blankPercent}])
      }}>Add time</button>
    {error&&<p role="alert" className="text-xs text-ember">{error}</p>}
  </div>
}
